/**
 * Platform
 */
export default class Platform {
  pf = navigator.platform;
  ua = (window.navigator.userAgent || '').toLowerCase();
  os = ''; // 'win' or 'other'
  device = ''; // 'pc' or 'sp'
  browser = '';

  /**
   * constructor
   */
  constructor() {
    this.checkOs();
    this.checkDevice();
    this.checkBrowser();
  }

  /**
   * check os
   */
  checkOs() {
    if (this.pf.indexOf('Win') != -1) {
      this.os = 'win';
    } else {
      this.os = 'other';
    }
  }

  /**
   * check device
   */
  checkDevice() {
    if (
      -1 != this.ua.indexOf('iphone') ||
      -1 != this.ua.indexOf('ipad') ||
      -1 != this.ua.indexOf('android')
    ) {
      this.device = 'sp';
    } else {
      this.device = 'pc';
    }
  }

  /**
   * check browser
   */
  checkBrowser() {
    if (-1 != this.ua.indexOf('msie') || -1 != this.ua.indexOf('trident')) {
      this.browser = 'ie';
    } else if (-1 != this.ua.indexOf('edge')) {
      this.browser = 'edge';
    } else if (-1 != this.ua.indexOf('chrome')) {
      this.browser = 'chrome';
    } else if (-1 != this.ua.indexOf('safari')) {
      this.browser = 'safari';
    } else if (-1 != this.ua.indexOf('firefox')) {
      this.browser = 'firefox';
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/utils/platform.js